import {Path, PathValue, useController, UseFormReturn} from 'react-hook-form'

/**
 * Watches and registers a form field using useController, ensuring the field is always registered
 * even if rendered conditionally. Returns the current value of the field.
 *
 * @template TFormValues - The form values object type.
 * @template K - The key of the field to watch.
 * @param methods - The useForm return object.
 * @param key - The field name (path) to watch.
 * @returns The current value of the watched field.
 */
export function useWatchFormValue<TFormValues extends object, K extends Path<TFormValues>>(
  methods: UseFormReturn<TFormValues>,
  key: K
): PathValue<TFormValues, K> {
  return useController<TFormValues, K>({
    name: key,
    control: methods.control,
    disabled: false
  }).field.value
}
